<template lang="pug">
.user-info-navigation
  //- 页面说明
  .description
    p 根据相关法律法规要求，以下是我们收集和使用的用户信息类型说明。

  //- 导航列表
  .navigation-list
    .nav-item(
      v-for="item in navigationItems",
      :key="item.id",
      @click="navigateToPage(item)"
    )
      .nav-content
        .nav-title {{ item.title }}
      .nav-arrow
        .arrow-icon

  //- 底部说明
  //- .footer-tips
  //-   p.tips-title 温馨提示：
  //-   p 1. 我们严格保护您的个人信息安全，仅用于提供服务和优化体验。
  //-   p 2. 您有权查询、更正、删除您的个人信息，详情请查看
  //-     a.privacy-policy-link(@click="openPrivacyPolicy") 隐私政策
  //-     | 。
</template>

<script>
import { setTitle, getTokenAndKey } from '@/utils';

import { getInfoCollection, isDataLoaded } from './js/getInfoCollection.js';

export default {
  name: 'UserInfoNavigation',
  data() {
    return {
      // 错误信息
      error: '',
      // 导航锁，防止重复点击
      isNavigating: false,
      navigationItems: [
        {
          id: 'basicInfo',
          title: '基本信息',
          description: '昵称、手机号、性别等基础用户信息',
          path: '/personalInfoCollectionList/basicInfo',
        },
        {
          id: 'identityInfo',
          title: '用户身份信息',
          description: '姓名、身份证号等实名认证信息',
          path: '/personalInfoCollectionList/identityInfo',
        },
        {
          id: 'locationInfo',
          title: '用户位置信息',
          description: '地理位置信息及位置相关数据',
          path: '/personalInfoCollectionList/locationInfo',
        },
        {
          id: 'usageRecords',
          title: '用户使用记录',
          description: '使用记录、行为数据及服务记录',
          path: '/personalInfoCollectionList/usageRecords',
        },
        {
          id: 'additionalService',
          title: '附加服务',
          description: '相机、相册等附加服务权限',
          path: '/personalInfoCollectionList/additionalService',
        },
      ],
    };
  },
  async created() {
    setTitle('个人信息收集清单');
    // 如果数据未加载，则预加载
    if (!isDataLoaded()) {
      await this.preloadUserData();
    }
  },
  methods: {
    // 预加载用户数据
    async preloadUserData() {
      this.error = '';
      try {
        const data = await getTokenAndKey();
        const {
          userNewId, userGuid, mobile, token,
        } = data;
        await getInfoCollection({
          userNewId, userGuid, mobile, token,
        });
      } catch (error) {
        this.error = '数据加载失败，请稍后重试';
      }
    },

    // 导航到指定页面
    navigateToPage(item) {
      // 如果正在导航中，直接返回
      if (this.isNavigating) {
        return;
      }

      this.isNavigating = true;

      this.$router.push({
        path: item.path,
        query: { from: 'navigation', title: item.title },
      }).catch(() => {}).finally(() => {
        // 延迟解锁，防止快速重复点击
        setTimeout(() => {
          this.isNavigating = false;
        }, 10);
      });
    },

    // 打开隐私政策
    openPrivacyPolicy() {
      window.open('https://h.c3x.me/1YtUvK', '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-navigation {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 0.2rem;
}

// 页面说明
.description {
  background-color: #fff;
  margin-bottom: 0.1rem;
  padding: 0.16rem;
}

.description p {
  font-size: 0.14rem;
  color: #666;
  line-height: 0.2rem;
  margin: 0;
}

// 导航列表
.navigation-list {
  background-color: #fff;
  margin-bottom: 0.1rem;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 0.1rem 0.16rem;
  border-bottom: 0.01rem solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.nav-item:last-child {
  border-bottom: none;
}

.nav-item:hover {
  background-color: #f8f8f8;
}

// 导航内容
.nav-content {
  flex: 1;
  margin-right: 0.12rem;
}

.nav-title {
  font-size: 0.16rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 0.04rem;
}

// 箭头图标
.nav-arrow {
  width: 0.16rem;
  height: 0.16rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow-icon {
  display: block;
  width: 0.08rem;
  height: 0.08rem;
  border-right: 0.02rem solid #999;
  border-bottom: 0.02rem solid #999;
  transform: rotate(-45deg);
}

// 底部说明
.footer-tips {
  margin: 0.16rem 0.16rem 0.32rem 0.16rem;
  padding: 0.16rem;
  background-color: #f9f9f9;
  border-radius: 0.08rem;
  font-size: 0.12rem;
  color: #999;
}

.tips-title {
  font-weight: 500;
  color: #666;
  margin: 0 0 0.08rem 0;
}

.footer-tips p {
  margin: 0.08rem 0;
  line-height: 0.18rem;
}

.footer-tips p:last-child {
  margin-bottom: 0;
}

.privacy-policy-link {
  color: #1890ff;
  text-decoration: none;
  cursor: pointer;
}

.privacy-policy-link:hover {
  text-decoration: underline;
}
</style>
